import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { BFile_filters } from "./slices/FS/BFile_Filters";
import { createManageSchedulerFilters } from "./slices/ManageSchedulersSlice/ManageSchedulerSlice";
import { createActivatedSchedulerFilters } from "./slices/ActivatedSchedulerSlice/activatedSchedulerSlice";
import { createUserType } from "./slices/User_Type/userTypeSlice";
import { createInvitedSchedulerFilters } from "./slices/InvitedSchedulerSlice/invitedSchedulerSlice";
import { createInactiveSchedulerFilters } from "./slices/InActiveSchedulerSlice/inActiveSchedulerSlice";
import { createRSFS_GRIDFilters } from "./slices/FS/RSFS-gridSlice";
import { createRSFS_CARDFilters } from "./slices/FS/RSFS-cardSlice";
import { typeOfCallSelectedEa } from "./slices/EASlice/typeOfCallSelected";
import { createAMDashboardFilter } from "./slices/AMSlice/AMDashboardSlice";
import { createGlobalDashboardFilter } from "./slices/GlobalDashboardSlice/GlobalDashboardSlice";
import { createRSFS_ModalState } from "./slices/FS/RSFSModalState";
import {  useUserInfo } from "./slices/user/userInfo";
import { createNotificationUI } from "./slices/NotificationSlice/notification_seen_unseen";
import { AgencySlice } from "./slices/AgencySlice/AgencySlice";
// import { useSocketStore } from "./slices/NotificationSlice/notification_slice";


export const useBoundStore = create(
  devtools(
    persist(
      (set, get) => {
        const initialState = {
          ...createUserType(set, get),
          ...BFile_filters(set, get),
          ...createManageSchedulerFilters(set, get),
          ...createActivatedSchedulerFilters(set, get),
          ...createInvitedSchedulerFilters(set, get),
          ...createInactiveSchedulerFilters(set, get),
          ...createRSFS_GRIDFilters(set, get),
          ...createUserType(set, get),
          ...BFile_filters(set, get),
          ...createManageSchedulerFilters(set, get),
          ...createActivatedSchedulerFilters(set, get),
          ...createInvitedSchedulerFilters(set, get),
          ...createInactiveSchedulerFilters(set, get),
          ...createRSFS_GRIDFilters(set, get),
          ...createRSFS_CARDFilters(set, get),
          ...typeOfCallSelectedEa(set, get),
          ...createAMDashboardFilter(set, get),
          ...createGlobalDashboardFilter(set, get),
          ...createRSFS_ModalState(set, get),
          ...useUserInfo(set, get),
          ...createNotificationUI(set, get),
          ...AgencySlice(set, get),
          // ...useSocketStore(set,get),
        };

        return {
          ...initialState,
          reset: () => set(initialState), // Reset store
        };
      },
      {
        name: "zustand-storage", // LocalStorage Key
      }
    ),
    { name: "Zustand Store" }
  )
);



// WEBPACK FOOTER //
// ./src/store/useBoundStore.js